import Empty from '../../components/Display/Empty'
import CheckAnimation from '../../assets/animations/check.json'

const ConfirmedEmail = () => {
  return (
    <div className="flex flex-col justify-center items-center h-full">
            <h1>Correo confirmado</h1>
            <Empty
              isFromLoading={true}
              animationProps={{
                height: 200,
                width: 200,
                animation: CheckAnimation,
              }}
              lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
              loop={false}
            ></Empty>
          </div>
  )
}

export default ConfirmedEmail